import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SidebarModule } from 'primeng/sidebar';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { AvatarModule } from 'primeng/avatar';
import { StyleClassModule } from 'primeng/styleclass';
import { Sidebar } from 'primeng/sidebar';
import { Router } from '@angular/router';
import { AppSettingsService } from '../../services/app-settings.service';
import { Subject, takeUntil } from 'rxjs';
import { HttpErrorResponse, HttpParams } from '@angular/common/http';

@Component({
     selector: 'app-side-menu',
     standalone: true,
     imports: [SidebarModule, ButtonModule, RippleModule, AvatarModule, StyleClassModule],
     templateUrl: './side-menu.component.html',
     styleUrl: './side-menu.component.scss'
})

export class SideMenuComponent implements OnInit {
     @ViewChild('sidebarRef') sidebarRef!: Sidebar;
     @Input() sidebarVisible = true;
     @Output() emitSideBarStat = new EventEmitter<Event>();
     version: string = '';
     private readonly destroySubject = new Subject();

     constructor(
          private router: Router,
          private appSettingsService: AppSettingsService,
     ) { }

     ngOnInit() {
          let params = new HttpParams();
          params = params.append('application_id', 2);
          this.appSettingsService.getAppVersion(params)
          .pipe(takeUntil(this.destroySubject))
          .subscribe(
               {
                    next: (response: {version: string}) => {
                         this.version = response?.version ? response.version : '';
                    },
                    error: (error: HttpErrorResponse) => {
                         
                    }
               }
          );
     }

     closeCallback(e: MouseEvent): void {
          this.emitSideBarStat.emit();
          this.sidebarVisible = !this.sidebarVisible;
     }

     goToPage(page: string) {
          if (page) {
               switch (page) {
                    case 'dashboard':
                         this.router.navigate(['/dashboard']);
                         break;
                    case 'organisations':
                         this.router.navigate(['/organisations']);
                         break;
                    case 'organisation-subscriptions':
                         this.router.navigate(['/organisation-subscriptions']);
                         break;
                    case 'transaction-credit-correction':
                         this.router.navigate(['/transaction-credit-correction']);
                         break;
                    case 'organisation-credit-correction':
                         this.router.navigate(['/organisation-credit-correction']);
                         break;
                    case 'subscriptions-master':
                         this.router.navigate(['/subscriptions-master']);
                         break;
                    case 'manage-users':
                         this.router.navigate(['/manage-users']);
                         break;
                    case 'onboard-users':
                         this.router.navigate(['/onboard-users']);
                         break;
                    case 'user-trails':
                         this.router.navigate(['/user-trails']);
                         break;
                    case 'current-active-sessions':
                         this.router.navigate(['/current-active-sessions']);
                         break;
                    case 'gva-roles':
                         this.router.navigate(['/gva-roles']);
                         break;
                    case 'plans':
                         this.router.navigate(['/plans']);
                         break;
                    case 'plan-roles':
                         this.router.navigate(['/plan-roles']);
                         break;
                    case 'subscription-types':
                         this.router.navigate(['/subscription-types']);
                         break;
                    case 'transaction-type-master':
                         this.router.navigate(['/transaction-type-master']);
                         break;
                    case 'maintain-transaction-types':
                         this.router.navigate(['/maintain-transaction-types']);
                         break;
                    case 'version-management':
                         this.router.navigate(['/version-management']);
                         break;
                    case 'end-of-day-runs':
                         this.router.navigate(['/end-of-day-runs']);
                         break;
                    default:
                         this.router.navigate(['/dashboard']);
                         break;
               }
          }
     }

}